// NextconMembersData.js

export const MEMBER_SECTIONS = [

  {
    id: "director",
    title: "NEXTCON Lab & SCVIC CENTRE Director",
    columns: 1,
    members: [
      {
        name: "Prof. Burak Kantarci",
        role: "Program Director",
        image: "BurakNewProfile.jpg",
        alt: "Burak Kantarci"
      }
    ]
  },

  {
    id: "coordination",
    title: "Lab Coordination and Administration",
    columns: 2,
    members: [
      {
        name: "Dr. Sachin Trankatwar",
        role: "Laboratory Coordinator (interim) and Postdoctoral Researcher",
        image: "Photo_Sachin.jpg",
        alt: "Sachin Trankatwar"
      },
      {
        name: "Iraz Eliz Deniz",
        role: "Project Coordinator",
        image: "NEXTCON-Elis.jpg",
        alt: "Iraz Eliz Deniz"
      }
    ]
  },

  {
    id: "postdocs",
    title: "Postdoctoral Researchers",
    columns: 3,
    members: [
      { name: "Dr. Nilesh Chakraborty", role: "", image: "Nilesh_uOttawa.jpg", alt: "Nilesh Chakraborty" },
      { name: "Dr. Sudipta Acharya", role: "", image: "sudipta_uOttawa.jpg", alt: "Sudipta Acharya" },
      { name: "Dr. Poonam Lohan", role: "", image: "Poonam New.png", alt: "Poonam Lohan" }
    ]
  },

  {
    id: "phd",
    title: "Ph.D Students",
    columns: 4,
    members: [
      { name: "Didem Cicek Simsek", role: "Ph.D - Digital Transformation and Innovation", image: "NEXTCON-Didem.jpg", alt: "Didem Cicek Simsek" },
      { name: "Samhita Kuili", role: "Ph.D - Elec. and Comp. Eng", image: "NEXTCON-Samhita.jpg", alt: "Samhita Kuili" },
      { name: "Murat Arda Onsu", role: "Ph.D - Computer Science", image: "NEXTCON-Arda.png", alt: "Murat Arda Onsu" },
      { name: "Parisa Fard Moshiri", role: "Ph.D - Elec. and Comp. Eng", image: "NEXTCON-Parissa.jpg", alt: "Parisa Fard Moshiri" },
      { name: "Ghazal Asemian", role: "Ph.D - Elec. and Comp. Eng", image: "NEXTCON-Ghazal.png", alt: "Ghazal Asemian" },
      { name: "Xuli Cai", role: "Ph.D - Computer Science", image: "NEXTCON-Xuli.jpg", alt: "Xuli Cai" },
      { name: "Lansu Dai", role: "Ph.D - Computer Science", image: "NEXTCON-Lansu.jpg", alt: "Lansu Dai" },
      { name: "Hanqing Zhou", role: "Ph.D - Computer Science", image: "NEXTCON-Hanqing.png", alt: "Hanqing Zhou" },
      { name: "Xinyu Zhu", role: "Ph.D - Elec. and Comp. Eng", image: "zhu.png", alt: "Xinyu Zhu" },
      { name: "Djad Benguerra", role: "Ph.D - Computer Science", image: "Profile_Picture_Djad_BENGUERRA.jpg", alt: "Djad Benguerra" }
    ]
  },

  {
    id: "masters",
    title: "Master's Students",
    columns: 4,
    members: [
      { name: "Oliver Benning", role: "Master in Computer Science", image: "NEXTCON-Oliver.jpg", alt: "Oliver Benning" },
      { name: "Tony Zhang", role: "Master in Elec. and Comp. Eng", image: "NEXTCON-ZHANGYueteng.jpg", alt: "Yueteng Zhang" },
      { name: "Arild Yonkeu Tchana", role: "Master in Computer Science", image: "NEXTCON-Arild.jpg", alt: "Arild Yonkeu Tchana" },
      { name: "Harsh Patel", role: "Master in Elec. and Comp. Eng", image: "Harsh Patel.jpg", alt: "Harsh Patel" },
      { name: "Andrea Masini", role: "Master of Computer Science and Engineering", image: "NEXTCON-Andrea.jpg", alt: "Andrea Masini" },
      { name: "Arman Dogru", role: "Master of Computer Science and Engineering", image: "arman.jpg", alt: "Arman Dogru" }
    ]
  },

  {
    id: "bachelor",
    title: "Bachelor Students",
    columns: 2,
    members: [
      { name: "Arin Barak", role: "Bachelor in Computer Science", image: "Arin Barak.jpeg", alt: "Arin Barak" },
      { name: "Berkay Caliskan", role: "Bachelor in Computer Science", image: "Berkay Caliskan headshot.jpg", alt: "Berkay Caliskan" }
    ]
  }

];